import React, { Component } from "react";
import {Card,CardFooter,CardFooterItem
  ,CardContent,Title,CardImage,CardHeader,CardHeaderTitle,Column} from 'bloomer'
import {Link} from 'gatsby'
import {HTMLContent} from '../content'
import PropTypes from "prop-types";
const LinkText = 'Read More...';


class ProfileItem extends Component
{
  constructor(){
    super()
    this.handleClick= this.handleClick.bind(this);
  }

  handleClick(e){
    e.preventDefault()
    const {onClick,profile} = this.props;
    onClick && onClick(profile)
  }

  render() {
    const {profile,defaultImage} = this.props;
    const image = (profile.image && profile.image.src && profile.image) || defaultImage
    return (
      <Column className='is-4-widescreen is-6-tablet'>
      <Card>
        {profile.jobTitle &&
        <CardHeader>
          <CardHeaderTitle>
            {profile.jobTitle}
          </CardHeaderTitle>
        </CardHeader>
        }
        {
          image &&
          <CardImage isFullWidth >
            <figure className='image is-4by3' >
              <img
                style={{objectFit:'cover',objectPosition:'0 0'}}
                src={image.src}
                alt={image.alt}
              />
            </figure>
          </CardImage>
        }
        <CardContent>
          <Title isSize={4}>
            {profile.title}
          </Title>
          <HTMLContent
            content={profile.excerpt}
          />
        </CardContent>
        <CardFooter>
          <CardFooterItem>
            <Link onClick={this.handleClick} to={'#'}>
              {LinkText}
            </Link>
          </CardFooterItem>
        </CardFooter>
      </Card>
      </Column>
    );
  }
}

ProfileItem.propTypes = {
  profile:PropTypes.shape({
    title:PropTypes.string,
    excerpt: PropTypes.string,
    image: PropTypes.shape({
      alt:PropTypes.string,
      src:PropTypes.string
    }),
    jobTitle:PropTypes.string,
  }),
  defaultImage: PropTypes.shape({
    alt:PropTypes.string,
    src:PropTypes.string
  }),
  onClick:PropTypes.func,
};

ProfileItem.defaultProps = {};

export default ProfileItem;

